import { createSlice } from '@reduxjs/toolkit';

//result of one-shot actions (register, login, withdraw, ...) so a page can react once:
//state[name] = { ok, m, data, n } - `n` changes on every result
const slice = createSlice({
  name: 'flow',
  initialState: {},
  reducers: {
    setFlow: (state, action) => {
      const { name, ok, m, data } = action.payload;
      const prev = state[name];
      state[name] = { ok: !!ok, m: m || '', data: data === undefined ? null : data, n: prev ? prev.n + 1 : 1 };
    }
  }
});

export const { setFlow } = slice.actions;
export default slice.reducer;
